import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=938079c0&scoped=true&"
import script from "./BaseBanner.vue?vue&type=script&lang=js&"
export * from "./BaseBanner.vue?vue&type=script&lang=js&"
import style0 from "./BaseBanner.vue?vue&type=style&index=0&id=938079c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938079c0",
  null
  
)

export default component.exports